import { ApiNames } from "components/Common/ApiManagement/apiServices";
import axiosInstance from "components/Common/ApiManagement/axiosInstance";
import { handleErrors } from "components/Common/common";
import { useState } from "react";
import {
    Card,
    Input,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    DropdownToggle
} from "reactstrap"
import OrganizationForm from "./OrganizationForm";
import * as Yup from 'yup'
import { useFormik } from "formik";

const SelectOrganization = ({ loginAfterOrgCreation }) => {
    const [suggestions, setSuggestions] = useState([]);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [orgInputValue, setOrgInputValue] = useState("");
    const [addOrgButton, setAddOrgButton] = useState(false);

    const [modal, setModal] = useState(false);
    const [isModifying, setIsModifying] = useState(false);

    const toggleDropdown = () => setDropdownOpen((prevState) => !prevState);

    const orgValidation = useFormik({
        enableReinitialize: true,

        initialValues: {
            branch: '',
            agency: '',
            office: undefined,
            city: undefined,
            state: undefined,
            securityContact: undefined
        },
        validationSchema: Yup.object({
            branch: Yup.string().required("Please Enter Your Branch"),
            agency: Yup.string().required("Please Enter Your Agency")
        }),
        onSubmit: values => {
            handleSubmit(values)
        },
    })

    const handleSubmit = async (values) => {
        try {
            setIsModifying(true)
            const { data } = await axiosInstance.post(ApiNames.ADD_ORGANIZATION, values)
            if (data.status) {
                setModal(false)
                loginAfterOrgCreation(data.data)
            }
        } catch (error) {
            handleErrors(error)
        } finally {
            setIsModifying(false)
        }
    }

    const fetchSuggestions = async (query) => {
        if (!query) {
            setSuggestions([]);
            return;
        }
        try {
            const { data } = await axiosInstance.get(`${ApiNames.LIST_ORGANIZATION}?search=${query}`)
            setSuggestions(data.data);
            setDropdownOpen(data.data.length > 0)
            setAddOrgButton(query.length > 2 && !data.data.length > 0)
        } catch (error) {
            handleErrors(error)
        }
    };

    const handleOrgInputChange = e => {
        const value = e.target.value;
        setOrgInputValue(value);
        fetchSuggestions(value);
    };

    const handleSelect = org => {
        setOrgInputValue(org.branch);
        setSuggestions([]);
        setDropdownOpen(false);
        loginAfterOrgCreation(org._id)
    };

    return (
        <div>
            <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                <DropdownToggle tag="div" className="w-100">
                    <div className="mb-3 position-relative">
                        <label style={{ color: '#49bc42' }} className="text-center" htmlFor="">
                            Choose or create organization to complete sign in
                        </label>
                        <Input
                            name="organization"
                            type="text"
                            className="form-control py-2"
                            placeholder="Enter organization"
                            onChange={handleOrgInputChange}
                            value={orgInputValue || ""}
                        />
                        {addOrgButton && (
                            <button
                                className="position-absolute btn btn-primary waves-effect waves-light"
                                style={{
                                    top: '46%',
                                    right: '1.5%',
                                    padding: '3px 10px'
                                }}
                                onClick={(e) => {
                                    e.preventDefault()
                                    setModal(true)
                                    orgValidation.values.branch = orgInputValue
                                }}
                            >
                                <i className="mdi mdi-plus fw-bold font-size-17 text-center"></i>
                            </button>
                        )}
                    </div>
                </DropdownToggle>
                {suggestions.length > 0 && (
                    <DropdownMenu className="w-100">
                        {suggestions.map((org, index) => (
                            <DropdownItem key={index} onClick={() => handleSelect(org)}>
                                {org.branch}
                            </DropdownItem>
                        ))}
                    </DropdownMenu>
                )}
            </Dropdown>
            <OrganizationForm
                modal={modal}
                setModal={setModal}
                isModifying={isModifying}
                orgValidation={orgValidation}
            />
        </div>
    )
}

export default SelectOrganization